import { render, staticRenderFns } from "./text_img.vue?vue&type=template&id=1ab2ea0a&scoped=true&"
import script from "./text_img.vue?vue&type=script&lang=js&"
export * from "./text_img.vue?vue&type=script&lang=js&"
import style0 from "./text_img.vue?vue&type=style&index=0&id=1ab2ea0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2ea0a",
  null
  
)

export default component.exports